import Swiper from 'swiper'

const homeSlideshow = document.querySelector('.home-slideshow .slideshow') !== null;


if(homeSlideshow){
    let nbSlides = document.querySelectorAll('.home-slideshow .slideshow__slide').length;
    let dataSlideAuto = document.querySelector('.home-slideshow .slideshow').getAttribute('data-slide_auto');
    let dataSlideSpeed = document.querySelector('.home-slideshow .slideshow').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';

    let config = {
        effect : 'fade',
        grabCursor : 'true',
        speed: 700,
        loop : true,

        fadeEffect: {
            crossFade: true
        },

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },
        
        pagination: {
            el: '.home-slideshow__pagination',
            type: 'bullets',
            clickable: true
        },

    }

    if(dataSlideAuto === '1'){
        config.autoplay = {
            delay: dataSlideSpeed,
            disableOnInteraction: false,
        }
    }

    if(nbSlides > 1) {
        let swiperHome = new Swiper('.home-slideshow .slideshow', config);
    }
}

// Slider Posts

let eventsSlides = document.querySelectorAll('.home-posts .swiper-container .swiper-slide').length;

let eventsConfig = {
    effect : 'slide',
    grabCursor : 'true',
    speed: 700,
    loop : true,
    loopedSlides : 0,
    
    breakpoints: {
        0: { // when window width is >= 0px 
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
        },

        960: { // when window width is >= 960px 
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 20,
        },

        1200: { // when window width is >= 1200px
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 30,
        },
    },

    fadeEffect: {
        crossFade: true
    },

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },

    navigation: {
        nextEl: `.home-posts__btn-next`,
        prevEl: `.home-posts__btn-prev`,
    }
}

if(eventsSlides > 2) {
    let swiperEvents = new Swiper('.home-posts .swiper-container', eventsConfig);
}

// Slider events
const eventsSlideshow = document.querySelector('.home-events .swiper-container') !== null;
        
if (eventsSlideshow) {
    let eventsSlides = document.querySelectorAll('.home-events .swiper-container .swiper-slide').length;

    let eventsConfig = {
        spaceBetween: 0,
        effect : 'fade',
        grabCursor : 'true',
        speed: 700,
        loop : true,
        slidesPerView: 1,

        fadeEffect: {
            crossFade: true
        },

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        navigation: {
            nextEl: `.home-events__btn-next`,
            prevEl: `.home-events__btn-prev`,
        },
    }

    if(eventsSlides > 1) {
        let swiperEvents = new Swiper('.home-events .swiper-container', eventsConfig);
    }
}






